import { getUserToken, isGuestUser } from '../webStorage/localStorage';

export const isUserLoggedIn = () => getUserToken() && !isGuestUser();
